import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8fbe276c")

_pushScopeId("data-v-8fbe276c")
const _hoisted_1 = { class: "audio-button" }
const _hoisted_2 = { class: "wrap-audio" }
const _hoisted_3 = { class: "wrap-button" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TitleOption = _resolveComponent("TitleOption")
  const _component_RadioInput = _resolveComponent("RadioInput")
  const _component_Button = _resolveComponent("Button")
  const _component_PopUpWithChevron = _resolveComponent("PopUpWithChevron")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PopUpWithChevron, {
      class: "audio",
      name: _ctx.iconMicName,
      "tooltip-btn": _ctx.micTooltip,
      "tooltip-chevron": _ctx.t('buttons.audioSettings'),
      size: "25px",
      "onUpdate:media": _ctx.toggleAudio
    }, {
      content: _withId(() => [
        _createVNode("div", _hoisted_2, [
          (_ctx.listMicrophone.length)
            ? (_openBlock(), _createBlock(_component_TitleOption, {
                key: 0,
                class: "title",
                title: _ctx.t('buttons.selectMicrophone')
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listMicrophone, (microphone) => {
            return (_openBlock(), _createBlock(_component_RadioInput, {
              class: "item",
              item: microphone.label + microphone.kind,
              label: microphone.label,
              checked: _ctx.isAudioActive(microphone),
              onChange: ($event: any) => (_ctx.updateAudioDevice(microphone)),
              name: "microphone"
            }, null, 8, ["item", "label", "checked", "onChange"]))
          }), 256)),
          (_ctx.canUseOutputDevice())
            ? (_openBlock(), _createBlock(_component_TitleOption, {
                key: 1,
                class: "title",
                title: _ctx.t('buttons.selectSpeaker')
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listSpeaker, (speaker) => {
            return (_openBlock(), _createBlock(_component_RadioInput, {
              class: "item",
              item: speaker.label + speaker.kind,
              label: speaker.label,
              checked: _ctx.isSpeakerActive(speaker),
              onChange: ($event: any) => (_ctx.updateAudioDevice(speaker)),
              name: "speaker"
            }, null, 8, ["item", "label", "checked", "onChange"]))
          }), 256))
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            class: "btn-audio-setting",
            mode: "flat",
            size: "l",
            onClick: _ctx.showAudioSettings
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('buttons.audioSettings')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["name", "tooltip-btn", "tooltip-chevron", "onUpdate:media"])
  ]))
})